export default {"src":"https://fishbrain.com/_next/static/media/ic_weather_night_179.3c71172c.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};